import React from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import { IProps, IHandlers } from './types';
import classNames from 'classnames';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { LocaleService } from 'internal-services/locale/locale.service';

const NS = 'DatePickerOverlay';

export default function DatePickerOverlay({
  currentDate,
  disablePastDate,
  disableFutureDate,
  handleDateUpdate,
  label,
  maxDate,
  staticType = false,
  todayBtn = false,
  children,
  className = false,
  renderDay,
}: IProps & IHandlers) {
  const IndexWrap = () => (
    <div>
      <div className={style.calenderWrap}>
        <div
          className={classNames({
            [style.calender]: true,
          })}
        >
          <Picker />
        </div>
      </div>
    </div>
  );

  const momentLocale = LocaleService.configureMomentLocale();

  const Picker = () => (
    <MuiPickersUtilsProvider utils={MomentUtils} locale={momentLocale}>
      <DatePicker
        // data-testid={'date-picker-over-lay-test-id'}
        // className={className? style.datePickerOverLayContainer : null}
        value={currentDate}
        autoOk
        disablePast={disablePastDate}
        disableFuture={disableFutureDate}
        disableToolbar
        orientation="landscape"
        variant={staticType ? 'static' : 'inline'}
        openTo="date"
        maxDate={maxDate ?? undefined}
        onChange={(date) => {
          // not needed unless using OK button to confirm
          //handleDateUpdate(date)
        }}
        onAccept={(date) => {
          handleDateUpdate(date);
        }}
        renderDay={renderDay}
        label={label ?? ''}
      />
    </MuiPickersUtilsProvider>
  );

  return (
    <>
      {!staticType ? (
        <IndexWrap />
      ) : (
        <>
          <Picker />
          {todayBtn && children && children}
        </>
      )}
    </>
  );
}
